module.exports = __webpack_public_path__ + "img/s05-bg1.2a836244.jpg";